var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mt-5 text-xs text-gray-600 max-w"},[_c('span',{staticClass:"inline-flex items-center px-2.5 py-0.5 rounded-md text-sm font-medium bg-gray-100 text-gray-800"},[_vm._v(" API v"+_vm._s(_vm.apiVersion)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }